<template>
  <va-page-not-found class="va-page-not-found-simple">
    <img src="@/assets/images/logo.svg" alt="Florida" slot="image" class="logo-image"/>
  </va-page-not-found>
</template>

<script>
import VaPageNotFound from './VaPageNotFound'

export default {
  name: 'vuestic-page-not-found-simple',
  components: {
    VaPageNotFound,
  },
}
</script>

<style lang="scss">
.va-page-not-found-simple {
  .logo-image {
    width: 19rem;
    height: auto;
    max-width: 100%;
    margin-bottom: 13%;
  }
}
</style>
